import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import i18n from 'i18next';
import axios from 'axios';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { classNames } from 'primereact/utils';
import { useAuth } from '../../_common/AuthContext';

const TwoFactorAuth = () => {
    const { auth, updateAuth, clearAuth } = useAuth();
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false)
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setErrorMessage('');

        if (!auth.Pin) {
            setErrorMessage(i18n.t('auth.two_factor_auth.pin_required'));
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await axios.post('/BBAuthentication/TwoFactorAuth', auth);
            const data = response.data;

            setIsSubmitting(false);
            clearAuth();

            if (data.IsSuccess) {
                window.location.href = data.ReturnUrl;
                setIsSuccess(data.IsSuccess);
            } else if (data.RedirectPage) {
                navigate(data.RedirectPage);
            } else {                
                setErrorMessage(data.ErrorMessage)
            }
        } catch (error) {
            setIsSubmitting(false);
            setErrorMessage(error.response?.data || error.message || i18n.t('auth.two_factor_auth.an_error_occurred'));
        }
    };

    const handleInputChange = (e, field) => {
        const value = e.target.value;
        const updatedAuth = { ...auth, [field]: value };
        updateAuth(updatedAuth)
    };

    return (
        <div className="login-inner">
            <div className="body-inner">
                {!isSuccess && (
                    <form className="login-form" onSubmit={handleSubmit}>
                        <a id="btnBack" className="cursor-pointer flex align-items-center w-min" type="button" onClick={() => navigate(-1)}>
                            <i className="pi pi-arrow-left mr-2" style={{ fontSize: '1.2rem' }}></i>
                            <p style={{ fontSize: '17px' }}>{auth.UserEmail}</p>
                        </a>

                        <h4 className="mb-3 font-bold">{i18n.t('auth.two_factor_auth.token_based_authentication')}</h4>

                        <div className="mb-3">
                            <Password id="pinInput" autoFocus value={auth.Pin || ''} onChange={(e) => handleInputChange(e, 'Pin')} placeholder={i18n.t('auth.two_factor_auth.pin')}
                                inputClassName="w-full" className={classNames('w-full', { 'p-invalid': !!errorMessage })} feedback={false}
                            />
                            {errorMessage && <small className="p-error" id="password-help">{errorMessage}</small>}
                        </div>

                        <div className="grid">
                            <div className="col-6" style={{ marginTop: "8px" }}>
                                <a href="login" className='text-primary'>{i18n.t('auth.two_factor_auth.change_account')}</a>
                            </div>
                            <div className="col-6">
                                <Button type="submit" className="w-full" label={i18n.t('auth.two_factor_auth.submit')} loading={isSubmitting} disabled={isSubmitting} />
                            </div>
                        </div>
                    </form>
                )}
                {isSuccess && (
                    <div className='login-form'>
                        <div className="text-2xl font-bold text-center">
                            {i18n.t('auth.auth_successfully')}
                        </div>
                        <div className="text-center" style={{ marginTop: '10px' }}>
                            {i18n.t('auth.auth_redirecting')}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TwoFactorAuth;
